<template>
  <div class="ie-edge-banner" v-if="isEdge && bannerActive" >
    <div class="vert-center">
      Please switch browsers for the best viewing experience. We recommend
      <a href="https://www.google.ca/chrome/browser/desktop/index.html" target="_blank">Chrome</a> or
      <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a>.
      <i class="fa fa-window-close" aria-hidden="true" v-on:click="disableBanner"></i>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        bannerActive: true
      }
    },
    methods: {
      disableBanner () {
        this.bannerActive = false
      }
    },
    computed: {
      isEdge() {
        if (/MSIE 10/i.test(navigator.userAgent)) {
          // This is internet explorer 10
          return true
        }

        if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
          // This is internet explorer 9 or 11
          return true
        }

        if (/Edge\/\d./i.test(navigator.userAgent)) {
          // This is Microsoft Edge
          return true
        }

        return false
      }
    }
  }

</script>

<style scoped lang="scss">
  .ie-edge-banner {
    position: fixed;
    z-index: 9999;
    height: 60px;
    text-align: center;
    width: 100%;
    top: 0;
    left: 0;
    margin-top: 0px;
    margin-left: 0px;
    background: #e89e8b; //rgba(255, 0, 0, 0.4);
    cursor: pointer;
    .vert-center {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
    }
    a {
      color: white;
      text-decoration: underline;
      &:hover,
      &:active,
      &:visited {
        color: white;
      }
    }
    i {
      padding-left: 12px;
      transform: scale(1.25, 1.25);
    }
  }

</style>



// WEBPACK FOOTER //
// edgeBanner.vue?79ff23f0